import { z } from "zod";

export interface IGetTourOpitonParams {
  tourOptionId: number;
  selectedmarketId: number;
  transferType?: TransferTypeEnum;
  noOfAdults: number;
  noOfChildren: number;
  activityDate: string;
  sharingBasis?: sharingBasisEnum;
}

export enum TransferTypeEnum {
  Oneway = "oneway",
  Return = "return",
}

export enum sharingBasisEnum {
  sharing = "SIC",
  private = "PVT",
  dp_sic_pk_sic = "DROP_SIC_PICKUP_SIC",
  dp_sic_pk_pvt = "DROP_SIC_PICKUP_PVT",
  dp_pvt_pk_sic = "DROP_PVT_PICKUP_SIC",
  dp_pvt_pk_pvt = "DROP_PVT_PICKUP_PVT",
}

export const zodDMCComboTourOption = z.object({
  tourOptionId: z.number(),
  onwardTransfer: z
    .enum([sharingBasisEnum.private, sharingBasisEnum.sharing])
    .nullish(),
  returnTransfer: z
    .enum([sharingBasisEnum.private, sharingBasisEnum.sharing])
    .nullish(),
});

export const zodDMCCombo = z.object({
  id: z.number().nullish(),
  name: z.string(),
  amount: z.number(),
  tourOptions: z.array(zodDMCComboTourOption),
});

export type TDMCComboTourOption = z.infer<typeof zodDMCComboTourOption>;
export type TDMCCombo = z.infer<typeof zodDMCCombo>;

export interface IWorldCity {
  id: number;
  city: string;
  city_ascii: string;
  lat: number;
  lon: number;
  country: string;
  country_iso2: string;
  country_iso3: string;
  simpleMaps_id: number;
}

export interface IDMCActivity {
  id: number;
  name: string;
  description: string;
  cityId: number;
  mongo_siteId: string;
  createdByUserId: number;
  createdAt: Date;
  updatedAt: Date;
  city: IWorldCity;
  priority?: number;
}

export interface IDMCActivityWTourOptions extends IDMCActivity {
  tourOptions: IDMCTourOption[];
}

export interface IDMCActivityWithTourOptionsAndRates
  extends IDMCActivityWTourOptions {
  tourOptions: IDMCTourOptionWithRates[];
}

export interface IDMCTourOption {
  id?: number;
  name: string;
  description: string;
  hasTimeSlots: boolean;
  hasMeal: boolean;
  hasGuide: boolean;
  hasTicket: boolean;
  pickupPickupTime?: number;
  dropPickupTime?: number;
}

interface TourOptionActivity {
  activity: IDMCActivity;
}

export interface IDMCTourOptionWithActivity
  extends IDMCTourOption,
    TourOptionActivity {}

export interface IDMCTourOptionWithRates
  extends IDMCTourOption,
    TourOptionActivity {
  transferRates: ITourOptionTransferRate[];
  ticketRates: ITourOptionTicketRate[];
}

export interface ITourOptionTransferRate {
  id: number;
  tourOptionId: number;
  marketId: number;
  mongoDbSiteId: string;
  amount: number;
  isPerPax: boolean;
  currencyCode: string;
  validFromDate: Date;
  validTillDate: Date;
  priority: number;
  createdByUserId: number;
  createdAt: Date;
  updatedAt: Date;
  description: string;
  transferType: string;
  sharingBasis: string;
  minPax: number;
  maxPax: number;
}

export interface ITourOptionTicketRate {
  id: number;
  tourOptionId: number;
  marketId: number;
  mongoDbSiteId: string;
  adultAmount: number;
  childAmount: number;
  isPerPax: boolean;
  validFromDate: Date;
  validTillDate: Date;
  priority: number;
  createdByUserId: number;
  createdAt: Date;
  updatedAt: Date;
}

export enum transferTypePickupDropEnum {
  pickup = "Pickup",
  drop = "Drop",
  pickupAndDrop = "Pickup & Drop",
}
